import { createSelector } from 'reselect'

const selectData = (state) => state.settings.users.self.data
const selectProfiles = (state) => state.settings.users.self.profiles
const selectLoader = (state) => state.settings.users.self.loader
const selectError = (state) => state.settings.users.self.error
const selectActionError = (state) => state.settings.users.self.actionError
const selectSortProperty = (state) => state.settings.users.self.sortProperty
const selectMailBoxData = (state) => state.settings.users.self.mailBoxData
const selectAddUserModalError = (state) => state.settings.users.self.addUserModalError
const selectCncAccess = (state) => state.settings.users.self.cncAccess
const selectFilterSearch = (state) => state.settings.users.self.filterSearch
const selectRoleFilter = (state) => state.settings.users.self.roleFilter
const selectMspRoleFilter = (state) => state.settings.users.self.mspRoleFilter
const selectManageableCompaniesData = (state) => state.settings.users.self.manageableCompaniesData
const selectUserInfo = (state) => state.settings.users.self.userInfo
const selectUserToUpdate = (state) => state.settings.users.self.userToUpdate
const selectAssignedCompaniesSearchFilter = (state) =>
  state.settings.users.self.assignedCompaniesSearchFilter
const selectToAssignCompaniesSearchFilter = (state) =>
  state.settings.users.self.toAssignCompaniesSearchFilter
const selectAssignedCompaniesMspRoleFilter = (state) =>
  state.settings.users.self.assignedCompaniesMspRoleFilter
const selectAssignedCompaniesPLanTypeFilter = (state) =>
  state.settings.users.self.assignedCompaniesPLanTypeFilter
const selectAssignedCompaniesData = (state) => state.settings.users.self.assignedCompaniesData
const selectToAssignCompaniesData = (state) => state.settings.users.self.toAssignCompaniesData
const selectToAssignSelectionData = (state) => state.settings.users.self.toAssignSelectionData
const selectIsToAssignDrawerOpen = (state) => state.settings.users.self.isToAssignDrawerOpen
const selectAllowedMspRoleIdFilter = (state) => state.settings.users.self.allowedMspRoleIdFilter
export const selectToAssignPlanTypeFilter = (state) =>
  state.settings.users.self.toAssignPlanTypeFilter
export const selectAssignedSelectionData = (state) =>
  state.settings.users.self.assignedSelectionData

const selectExternalData = (state) => selectData(state).externalUsers

const selectExternalDataWithRole = createSelector(selectExternalData, (items) =>
  items.filter((item) => item.role)
)

const selectExternalDataWithoutRole = createSelector(selectExternalData, (items) =>
  items.filter((item) => !item.role)
)

const selectFilteredInternalUsers = createSelector(
  selectData,
  selectFilterSearch,
  selectRoleFilter,
  selectMspRoleFilter,
  (data, filterSearch, roleFilter, mspRoleFilter) => {
    const items = data.internalUsers

    return items.filter((item) => {
      const searchValue = filterSearch.toLowerCase()
      const name = `${item.firstName} ${item.lastName}`.toLowerCase()

      return (
        name.includes(searchValue) &&
        (item.role === roleFilter || !roleFilter) &&
        (item.mspRoleIds?.includes(mspRoleFilter) || !mspRoleFilter)
      )
    })
  }
)

const selectAssignedCompaniesOptions = createSelector(
  selectManageableCompaniesData,
  (manageableCompaniesData) =>
    manageableCompaniesData.data.map(({ id, name }) => ({ value: id, label: name }))
)

export {
  selectData,
  selectProfiles,
  selectLoader,
  selectError,
  selectActionError,
  selectSortProperty,
  selectExternalDataWithRole,
  selectExternalDataWithoutRole,
  selectMailBoxData,
  selectAddUserModalError,
  selectCncAccess,
  selectFilteredInternalUsers,
  selectRoleFilter,
  selectMspRoleFilter,
  selectAssignedCompaniesOptions,
  selectAssignedCompaniesData,
  selectUserInfo,
  selectUserToUpdate,
  selectAssignedCompaniesSearchFilter,
  selectAssignedCompaniesMspRoleFilter,
  selectAssignedCompaniesPLanTypeFilter,
  selectManageableCompaniesData,
  selectToAssignSelectionData,
  selectIsToAssignDrawerOpen,
  selectAllowedMspRoleIdFilter,
  selectToAssignCompaniesData,
  selectToAssignCompaniesSearchFilter,
}
